
export interface IOnboardingOption {
  id: number;
  name: string;
}

export interface IOnboardingValidateUserInformation {
  email: string;
  country: string;
  medicalSpecialty: string;
}

export interface IOnboardingSendOrResendCode {
  email: string;
  isInvitedUser?: boolean;  
  lang?: string;
}

export interface IOnboardingAcceptTerms {
  isLicenseAccepted: boolean;
  isDoctor: boolean;
}
export interface IOnboardingCreateUser extends IOnboardingAcceptTerms {
  email: string;
  medicalSpecialty: string;
  country: string;
  language?: string;
  isInvitedUser?: boolean;
  /**
   * Optional password collected on the onboarding wrapper. When present, the
   * server hashes and stores it so the user can log in with email + password
   * immediately after completing the onboarding stepper.
   */
  password?: string;
}

export interface IOnboardingVerificationCode {
  code: string;
}

export interface IOnboardingVerifyCode extends IOnboardingSendOrResendCode, IOnboardingVerificationCode {
}

export interface IOnboardingEmailValidation {
  email: string;
  lang?: string;
}

